"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enumerable = void 0;
const applyEmpty_1 = require("../functions/applicators/applyEmpty");
const applyFrom_1 = require("../functions/applicators/applyFrom");
const applyRange_1 = require("../functions/applicators/applyRange");
const applyRepeat_1 = require("../functions/applicators/applyRepeat");
const EnumerableFactory_1 = require("../utilities/EnumerableFactory");
const isEnumerable_1 = require("../functions/isEnumerable");
/**
 * Provides a set of static methods for IEnumerable.
 */
class Enumerable {
    /**
     * Creates a new Enumerable from the input Iterable.
     * @example
     * ```typescript
     * const numbers = [1, 2, 3, 4];
     * const enumerable = Enumerable.from(numbers);
     * ```
     * @param src The Iterable to create an Enumerable from.
     * @returns A new Enumerable.
     */
    static from(src) {
        return (0, applyFrom_1.applyFrom)(new EnumerableFactory_1.EnumerableFactory(), src);
    }
    /**
     * Creates a new Enumerable from the input object.
     * @example
     * ```typescript
     * const obj = {
     *   foo: 1,
     *   bar: 'b'
     * };
     * const enumerable = Enumerable.from(obj);
     * ```
     * @param src The object to create an Enumerable from.
     * @returns A new Enumerable.
     */
    static fromObject(src) {
        return (0, applyFrom_1.applyFrom)(new EnumerableFactory_1.EnumerableFactory(), src);
    }
    /**
     * Creates an empty Enumerable.
     * @example
     * ```typescript
     * const empty = Enumerable.empty();
     * ```
     * @returns A new empty Enumerable.
     */
    static empty() {
        return (0, applyEmpty_1.applyEmpty)(new EnumerableFactory_1.EnumerableFactory());
    }
    /**
     * Generates a sequence of integral numbers within a specified range.
     * @param start The value of the first integer in the sequence.
     * @param count The number of sequential integers to generate.
     * @returns An IEnumerable<number> that contains a range of sequential integral numbers.
     */
    static range(start, count) {
        return (0, applyRange_1.applyRange)(new EnumerableFactory_1.EnumerableFactory(), start, count);
    }
    /**
     * Generates a sequence that contains one repeated value.
     * @typeparam TResult The type of the value to be repeated in the result sequence.
     * @param element The value to be repeated.
     * @param count The number of times to repeat the value in the generated sequence.
     * @returns An IEnumerable<T> that contains a repeated value.
     */
    static repeat(element, count) {
        return (0, applyRepeat_1.applyRepeat)(new EnumerableFactory_1.EnumerableFactory(), element, count);
    }
    /**
     * Determines if the passed in object is an Enumerable.
     * @param obj The item to test if it is an Enumerable or not.
     * @returns True if the obj is an Enumerable. False if not.
     */
    static isEnumerable(obj) {
        return (0, isEnumerable_1.isEnumerable)(obj);
    }
}
exports.Enumerable = Enumerable;
//# sourceMappingURL=Enumerable.js.map